import {
  ChangeDetectionStrategy,
  Component,
  ComponentRef,
  DestroyRef,
  Injector,
  OnInit,
  ViewChild,
  ViewContainerRef,
  createNgModule,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { FeatureToggleService } from 'ish-core/feature-toggle.module';

import type { CopilotComponent as OriginalComponent } from '../../shared/copilot/copilot.component';

@Component({
  selector: 'ish-lazy-copilot',
  standalone: false,
  templateUrl: './lazy-copilot.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LazyCopilotComponent implements OnInit {
  /*
   * WARNING!
   *
   * This file was automatically generated!
   * It should be updated using:
   *
   * ng g lazy-component extensions/copilot/shared/copilot/copilot.component.ts
   *
   */

  @ViewChild('anchor', { read: ViewContainerRef, static: true }) anchor: ViewContainerRef;

  private component: ComponentRef<OriginalComponent>;
  private destroyRef = inject(DestroyRef);

  constructor(
    private featureToggleService: FeatureToggleService,
    private injector: Injector
  ) {}

  ngOnInit() {
    this.featureToggleService
      .enabled$('copilot')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(async enabled => {
        if (enabled) {
          await this.renderComponent();
        } else {
          this.anchor.clear();
        }
      });
  }

  private async renderComponent() {
    const module = await import(`../../copilot.module`).then(m => m.CopilotModule);

    const { CopilotComponent: originalComponent } = await import('../../shared/copilot/copilot.component');

    const ngModuleRef = createNgModule(module, this.injector);

    this.component = this.anchor.createComponent(originalComponent, { ngModuleRef });

    this.component.changeDetectorRef.markForCheck();
  }
}
